export default function withAuthenticationHeaders(
  sessionId: string,
  headers: Record<string, string> = {},
): Record<string, string> {
  return {
    ...headers,
    Authorization: `Session ${sessionId}`,
  };
}
